/* eslint no-unused-expressions: 0, react/no-danger: 0 */
import React, { useEffect, useRef } from 'react';
import Observer from 'react-intersection-observer';
//import content from '../../content';
import { GAfireEvent } from '../Tracking';
import {fireTag} from '../../libs/analytics';
import { isEs } from "../../libs/lang";

/* eslint-disable global-require */
let content = {};

if (isEs()) {
  content = require('../../contentES').default.home.grant;
} else {
  content = require('../../content').default.home.grant;
}

const Grant = (props) => {
	const copy = content;

	const containerRef = useRef(null)

	useEffect(() => {
	})

	let scrollGrant = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(!window.location.href.includes('/sustainability/') &&
			!window.location.href.includes('/housing/') &&!window.location.href.includes('/map/')
			&& !scrollGrant
			&& document.querySelector('#grant-process').getBoundingClientRect().top <= (document.querySelector('nav').getBoundingClientRect().height + (window.innerHeight / 2))){
				scrollGrant = true;
				fireTag('S6');
			}
		});
	},[])

	return (
		<Observer
			tag='section'
			className="home__grant"
			id="grant-process"
			ref={containerRef}
			triggerOnce
			threshold={0.50}
			onChange={(inView) => {
				if (inView) {
					//GAfireEvent('home_S6');
					//fireTag("S6");
				}
			}}
		>
			<div className='container-copy'>
				<div className="grant__copy">
          <div className='bar'/>
					<h2 tabIndex="-1" dangerouslySetInnerHTML={{__html: copy.headline}}/>
					<p dangerouslySetInnerHTML={{__html: copy.copy}}/>
					<a
						target="_blank"
						href={copy.link.url}
						onClick={() => {
							fireTag("C9");
							//GAfireEvent('home_C20', {label: copy.link.label.toLowerCase()});
						}}
						rel="noreferrer"
						aria-label={isEs() ? "Aprende más sobre nuestro proceso de subvenciones - Abre en una nueva pestaña." : "Learn more about our grant process - Opens in new tab"}
					>
						{copy.link.label}
					</a>
				</div>
			</div>
			<div className='container-img' role="img" aria-label={copy.alt}/>
		</Observer>
	);
};

export default Grant;
